import { observable, action } from 'mobx'
import { set, defaults } from 'lodash'

export default class StorePrototype {
  @observable loading = false
  @observable success = null
  @observable err = null

  isSSR = (() => {return typeof window === 'undefined'})()

  @action handleChange = (e, { name, value, checked }) => {
    this.err = null
    this.success = null
    const { val } = defaults({val: value}, {val: checked}, {val: null})
    set(this, name, val)
  }

  catchError = err => {
    this.loading = false
    this.success = null
    if (err.response && err.response.data) {
      this.err = err.response.data
    } else if (err.message) {
      this.err = { message: err.message }
    } else {
      this.err = { message: 'Something is wrong… we are working on it!' }
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/_store.js